export default "__VITE_ASSET__D5ZiuSg2__"